/**
 * Generated by orval 🍺
 * Do not edit manually.
 * OnEarly Core API
 * OnEarly Core HTTP API
 * OpenAPI spec version: 0.0.1
 */
import * as zod from 'zod';

export const DownloadContentPdfParams = zod.object({
  accessGrant: zod.uuid().optional(),
  accessGrantPin: zod.string().optional(),
});

export type DownloadContentPdfParams = zod.input<typeof DownloadContentPdfParams>;
export type DownloadContentPdfParamsOutput = zod.output<typeof DownloadContentPdfParams>;
